import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const DaiIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/dai-logo.png" style={style} />
}
